import { render } from "./AddVehicle.vue?vue&type=template&id=b77bd8be&scoped=true"
import script from "./AddVehicle.vue?vue&type=script&lang=js"
export * from "./AddVehicle.vue?vue&type=script&lang=js"

import "./AddVehicle.vue?vue&type=style&index=0&id=b77bd8be&scoped=true&lang=css"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b77bd8be"]])

export default __exports__